var $ = global.$;

var velocity = require('velocity-animate');

var Modernizr = require('modernizr');

var _Base = require('./_Base');

var Quicklinks = _Base.extend({
  init: function() {
    var self = this;

    this.$toggles = this.$el.find('[data-sub-menu-toggle]');
    this.$subMenus = this.$el.find('[data-sub-menu]');

    this.$back = this.$el.find('[data-back-sub]');
    this.$close = this.$el.find('[data-close-sub]');

    this.$scroll = this.$el.find('[data-scroll]');

    this.html = this.$el.html();

    this.isMobile = this.$el.attr('id') === 'quickLinksWidgetClone';

    this.classes = {
      open: 'is-open',
      childrenOpen: 'is-child-open'
    };

    this.$toggles.on('click', function(event) {
      event.preventDefault();
      self.toggleSubMenu(this);
    });

    this.$close.on('click', function(event) {
      event.preventDefault();
      self.closeAll();
    });

    this.$back.on('click', function(event) {
      event.preventDefault();
      self.closeMenu($(this).parents(this.$subMenus).eq(0));
      if ($(this).parents('[data-sub-menu]').length === 1) {
        self.$el.trigger('Quicklinks:closed');
      }
    });

    $(document).on('click', function(event) {
      if (!$(event.target).closest(self.$el).length) {
        self.closeAll();
      }
    });

    this.$scroll.mCustomScrollbar({
      theme: 'dark',
      autoHideScrollbar: false,
      scrollInertia: 400,
      contentTouchScroll: 100
    });
  },

  getTrigger: function(menu) {
    var $menu = $(menu);
    var index = $menu.parents('[data-sub-menus]').eq(0).children().index(menu);
    var $trigger = $menu.parents('[data-sub-menus]').eq(0).siblings('[data-links]').find('[data-sub-menu-toggle]').eq(index);

    return $trigger;
  },

  getMenu: function(trigger) {
    var $trigger = $(trigger);
    var index = $trigger.parents('[data-links]').find('[data-sub-menu-toggle]').index(trigger);
    var $menu = $trigger.parents('[data-links]').next('[data-sub-menus]').children('[data-sub-menu]').eq(index);

    return $menu;
  },

  toggleSubMenu: function(trigger) {
    var isOpen = $(trigger).hasClass(this.classes.open);
    var menu = this.getMenu(trigger);
    if (isOpen) {
      this.closeMenu(menu, trigger);
    } else {
      this.openMenu(menu, trigger);
    }
  },

  openMenu: function(menu, trigger) {
    var self = this;
    var $menu = $(menu);
    var $trigger = trigger ? $(trigger) : this.getTrigger(menu);
    var $childTriggers = $menu.find('[data-sub-menu-toggle]');
    var $childMenus = $menu.find('[data-sub-menu]');
    var $siblings = $menu.siblings();

    var $parentMenu = $menu.parents('[data-sub-menu]').eq(0);

    var noTransforms = {
      left: this.isMobile ? '0' : '100%',
      opacity: '1'
    };
    var transforms = {
      translateX: '100%',
      opacity: '1'
    };

    $siblings.each(function() {
      self.closeMenu(this);
    });

    $menu.velocity(Modernizr.csstransforms ? transforms : noTransforms, {
      'display': 'block'
    });
    $menu.addClass(this.classes.open);
    $trigger.addClass(this.classes.open);
    $parentMenu.addClass(this.classes.childrenOpen);

    this.$el.trigger('Quicklinks:opened');
  },

  closeMenu: function(menu) {
    var self = this;
    var $menu = $(menu);
    var $trigger = this.getTrigger(menu);
    var $childTriggers = $menu.find('[data-sub-menu-toggle]');
    var $childMenus = $menu.find('[data-sub-menu]');
    var $siblings = $menu.siblings();

    var $parentMenu = $menu.parents('[data-sub-menu]').eq(0);

    var noTransforms = {
      left: this.isMobile ? '-100%' : '0',
      opacity: '0'
    };
    var transforms = {
      translateX: '0',
      opacity: '0'
    };

    if ($menu.hasClass(this.classes.open)) {

      $menu.velocity(Modernizr.csstransforms ? transforms : noTransforms, {
        'display': 'none'
      });
      $trigger.removeClass(this.classes.open);

      // if($childMenus.length > 0) {
      //   $childMenus.filter('.' + this.classes.open).velocity(configObj,{'display':'none'});
      //   $childTriggers.removeClass(this.classes.open);
      // }

      $parentMenu.removeClass(this.classes.childrenOpen);

    }

  },

  closeAll: function() {
    var self = this;
    this.closeMenu(this.$subMenus.filter(':visible').eq(0));
    this.$el.trigger('Quicklinks:closed');
  }
});

module.exports = Quicklinks;



/*****************
 ** WEBPACK FOOTER
 ** ./source/scripts/widgets/Quicklinks.js
 ** module id = 38
 ** module chunks = 0 1
 **/